import React, { Component } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import withRedux from "../../withRedux";
import {
	loadSupportedSports,
	updateProfile,
	addFavoriteClub,
	loadRatings,
	finishOnboarding,
	uploadAvatar,
	flash,
	refreshMyProfile,
	deleteAvatar,
	flashError,
} from "../../actions";
import { Ratings, Profile, Sport } from "../../types";
import { History } from "history";
import parseDataUrl from "parse-data-url";

type Props = {
	loadSupportedSports: typeof loadSupportedSports;
	updateProfile: typeof updateProfile;
	finishOnboarding: typeof finishOnboarding;
	addFavoriteClub: typeof addFavoriteClub;
	loadRatings: typeof loadRatings;
	refreshMyProfile: typeof refreshMyProfile;
	profile: Profile;
	sports: Sport[];
	ratings: Ratings;
	history: History;
	step?: number;
};

type State = {
	step: number;
};

export class OnboardingWizard extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			step: props.step || 1,
		};
	}

	componentDidMount() {
		this.props.loadSupportedSports();
		this.props.loadRatings();
	}

	onPreferencesChanges = values => {
		const updatedProfile = { ...this.props.profile, ...values };
		this.props.updateProfile(updatedProfile);

		if (this.state.step === 5) {
			this.props.finishOnboarding();
		} else {
			this.nextPage();
		}
	};

	onFavoriteClubChange = async (uuid: string) => {
		if (uuid) {
			await this.props.addFavoriteClub(uuid);
		}
		this.nextPage();
	};

	nextPage = () => {
		this.setState(state => {
			const step = Math.min(5, state.step + 1);
			this.props.history.push(`/onboarding/step${step}`);
			return { step };
		});
	};

	previousPage = () => {
		this.setState(state => {
			const step = Math.max(1, state.step - 1);
			return { step };
		});
	};

	onAvatarCropped = async (avatarSrc: string) => {
		const parsed = parseDataUrl(avatarSrc);
		const res = await uploadAvatar(parsed.data, parsed.mediaType);
		this.props.refreshMyProfile();

		if (res.error === false) {
			this.nextPage();
		} else {
			flashError(res.error);
		}
	};

	onAvatarRemove = async () => {
		await deleteAvatar();
		this.props.refreshMyProfile();
	};

	render() {
		switch (this.state.step) {
			case 1:
				return <Step1 profile={this.props.profile} onChange={this.onPreferencesChanges} />;
			case 2:
				return (
					<>
						<Step2
							profile={this.props.profile}
							onAvatarCropped={this.onAvatarCropped}
							onAvatarSkip={this.nextPage}
							onAvatarRemove={this.onAvatarRemove}
							onContinue={this.nextPage}
						/>
					</>
				);
			case 3:
				return (
					<>
						<Step3
							sports={this.props.sports}
							profile={this.props.profile}
							onChange={this.onPreferencesChanges}
						/>
					</>
				);
			case 4:
				return (
					<>
						<Step4 profile={this.props.profile} onChange={this.onFavoriteClubChange} />
					</>
				);
			case 5:
				return (
					<>
						<Step5
							profile={this.props.profile}
							onChange={this.onPreferencesChanges}
							ratings={this.props.ratings}
						/>
					</>
				);
		}
	}
}
function mapStateToProps({ utility, profile }) {
	return { ...utility, profile };
}
export default withRedux(
	{ loadSupportedSports, updateProfile, addFavoriteClub, loadRatings, finishOnboarding, refreshMyProfile },
	mapStateToProps
)(OnboardingWizard);
